import * as CryptoJS from 'crypto-js'
import request from './request'
export default {
  removeAaary:function(_arr, _obj) {
    var length = _arr.length;
    for (var i = 0; i < length; i++) {
        if (_arr[i] == _obj) {
            if (i == 0) {
                _arr.shift(); //删除并返回数组的第一个元素
                return _arr;
            }
            else if (i == length - 1) {
                _arr.pop();  //删除并返回数组的最后一个元素
                return _arr;
            }
            else {
                _arr.splice(i, 1); //删除下标为i的元素
                return _arr;
            }
        }
    }
}
}
export function downBlobFile(url, query, fileName) {
  return request({
    url: url,
    method: "get",
    responseType: "blob",
    params: query
  }).then(response => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      this.$notify.error("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    window.setTimeout(function() {
      window.URL.revokeObjectURL(blob);
      document.body.removeChild(link);
    }, 0);
  });
}

 /**
 *加密处理
 */
export const encryption = params => {
  let {data, type, param, key} = params;
  const result = JSON.parse(JSON.stringify(data));
  if (type === "Base64") {
    param.forEach(ele => {
      result[ele] = btoa(result[ele]);
    });
  } else {
    param.forEach(ele => {
      var data = result[ele];
      key = CryptoJS.enc.Latin1.parse(key);
      var iv = key;
      // 加密
      var encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.NoPadding
      });
      result[ele] = encrypted.toString();
    });
  }
  return result;
}

/**
 * 生成随机len位数字
 */
 export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
  if (date) random = random + Date.now()
  return random
}

/**
 * 时间格式化
 * @param datetime 时间戳
 * @param fmt 返回的格式类型;默认不填返回年月日
 * @returns {*} 返回对应格式日期
 * @author: MarkLin
 */
 export function formatDate(datetime, fmt) {
  const date = new Date(datetime) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const sdate = ('0' + date.getDate()).slice(-2)
  const date1 = date.getDate() // 去除0
  const hour = ('0' + date.getHours()).slice(-2)
  const minute = ('0' + date.getMinutes()).slice(-2)
  const second = ('0' + date.getSeconds()).slice(-2)
  // 拼接 年月日时分秒
  const result1 = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
  // 拼接 年月日时分
  const result2 = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute
  // 拼接 年月日
  const result3 = year + '-' + month + '-' + sdate
  const result4 = year + '年' + month + '月' + sdate + '日'
  const result5 = date1
  // 返回
  if (!fmt) {
    return result3
  } else if (fmt == 'hm') {
    return result2
  } else if (fmt == 'ymd') {
    return result4
  } else if (fmt == 'all') {
    return result1
  } else if (fmt == 'd') {
    return result5
  }
}

/**
 * @description: 本地时间转时间戳
 * @param {*} 本地时间
 * @return {*} 时间戳
 * @author: MarkLin
 */
 export function formatTime(val) {
  let new_str = val.replace(/:/g, '-')
  new_str = new_str.replace(/ /g, '-')
  const arr = new_str.split('-')
  const dutc = new Date(Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3] - 8, arr[4], arr[5]))
  return dutc.getTime()
}

/**
 * 获取日期
 */
export function getDate(){
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始，需要加 1
  const day = now.getDate().toString().padStart(2, '0');
  return `${year}年${month}月${day}日`;
}

/**
 * 获取星期
 */
export function getWeek(){
  const now = new Date();
  const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  return weekdays[now.getDay()];
}

/**
 * 获取时分秒
 */
export function getTime(){
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}



// WEBPACK FOOTER //
// ./src/util/util.js